import type { FormikHelpers, FormikValues } from 'formik';
import Form from '~/components/forms/Form';
import { CONTACT_FORM_DATA } from '~/constants/form';
import type { IContactContent } from '~/types/cms';
import { getApiURL } from '~/utils/api';
import { handleError } from '~/utils/form';
import type { ISlugMapping } from './getPageProps';
import useSearchParams from '~/hooks/useSearchParams';

export default function ContactPage({
	buttonLabel,
	slugMapping,
}: {
	buttonLabel: IContactContent['buttonLabel'];
	slugMapping: ISlugMapping;
}) {
	const searchParams = useSearchParams();

	const handleSubmit = async (
		values: FormikValues,
		recaptcha: string,
		setErrors: FormikHelpers<FormikValues>['setErrors'],
	) => {
		const promoSlug = searchParams.get('promoSlug') || '';
		const maybeInternalPromotionSlug = slugMapping[promoSlug];
		const internalPromotionSlug = maybeInternalPromotionSlug || Object.values(slugMapping)[0];

		const response = await fetch(`${getApiURL(internalPromotionSlug)}/contact`, {
			method: 'POST',
			body: JSON.stringify({
				values: {
					...values,
					recaptcha,
				},
			}),
			headers: {
				'Content-Type': 'application/json',
			},
		});

		const data = await response.json();

		if (response.ok) {
			window.location.assign('/contact/submission-received');
		} else {
			await Promise.reject(handleError(data, setErrors));
		}
	};

	return <Form onSubmit={handleSubmit} inputs={CONTACT_FORM_DATA} buttonChildren={buttonLabel} />;
}
